module.exports = __webpack_public_path__ + "assets/img/ellipses-full.8e69ea83.png";